import { Component, OnDestroy, OnInit } from '@angular/core';
import {ApiService} from '../../services/api.service';
import {Item} from '../../models/item.model';
import {PropertyByNamePipe} from '../../pipes/property-by-name';
import {DatePipe} from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { SearchService } from '../../services/search.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html'
})
export class ListComponent implements OnInit, OnDestroy {

  title = [
    '_LIST.TITLE_1',
    '_LIST.TITLE_2'
  ];

  vehicles: Array<any>;
  vehiclesBackup: Array<any>;

  private items: Array<Item>;
  itemsPerPage = 10;
  currentPage = 1;

  constructor(
    private api: ApiService,
    private propertyByNamePipe: PropertyByNamePipe,
    private datePipe: DatePipe,
    private translate: TranslateService,
    private searchService: SearchService
  ) {
    this.searchService.doSearch.subscribe(searchTerm => {
      if (searchTerm) {
        this.updateSearch(searchTerm);
      } else {
        this.vehicles = this.vehiclesBackup;
      }
    });
  }

  ngOnInit() {
    this.searchService.active = true;
    this.searchService.reset();

    this.api.getSharedItems().subscribe(
      (res) => {
        this.items = res;
        if (this.items.length > 0) {
          this.buildVehicles();
        } else {
          this.resetVehicles();
        }
      },
      () => {
        this.resetVehicles();
      }
    );
  }

  buildVehicles() {
    this.vehicles = [];
    this.vehiclesBackup = [];
    this.items.forEach((item) => {
      const itemData = JSON.parse(item.json);
      const imageIds = [];
      let defaultImageUrl = null;
      item.images.forEach(image => {
        if (image.defaultImage) {
          defaultImageUrl = image.id;
        } else {
          imageIds.push(image.id);
        }
      });
      const vehicle = {
        id: item.id,
        headline : this.propertyByNamePipe.transform(itemData.properties, 'Hersteller')
          + ' ' + this.propertyByNamePipe.transform(itemData.properties, 'Fahrzeugbenennung'),
        subline: this.datePipe.transform(this.propertyByNamePipe.transform(itemData.properties, 'Baujahr'), 'yyyy'),
        manufacturer: this.propertyByNamePipe.transform(itemData.properties, 'Hersteller'),
        name: this.propertyByNamePipe.transform(itemData.properties, 'Fahrzeugbenennung'),
        images: imageIds,
        defaultImage: (defaultImageUrl) ? defaultImageUrl : imageIds[0],
        description: '',
        data:
          {
            Baujahr : this.propertyByNamePipe.transform(itemData.properties, 'Baujahr'),
          }
      };
      this.vehicles.push(vehicle);
      this.vehiclesBackup.push(vehicle);
    });
    this.vehicles.sort((a, b) => {
      const aTitle = (a.manufacturer + a.name).toUpperCase();
      const bTitle = (b.manufacturer + b.name).toUpperCase();
      if (aTitle < bTitle) { return -1; }
      if (aTitle > bTitle) { return 1; }
      return 0;
    });
    this.vehiclesBackup.sort((a, b) => {
      const aTitle = (a.manufacturer + a.name).toUpperCase();
      const bTitle = (b.manufacturer + b.name).toUpperCase();
      if (aTitle < bTitle) { return -1; }
      if (aTitle > bTitle) { return 1; }
      return 0;
    });
  }

  ngOnDestroy(): void {
    this.searchService.active = false;
  }

  public  resetVehicles() {
    this.vehicles = [{
      id: 0,
      headline: this.translate.instant('_LIST.NO_VEHICLES'),
      subline: '',
      images: [
        'assets/images/placeholder-vehicles-small.jpg',
      ],
      description: this.translate.instant('_LIST.NO_VEHICLES_DESCRIPTION'),
      data : {
      }
  }];
  }

  pageChange(event) {
    this.currentPage = event;
    setTimeout(() => {
      this.scroll('header');
    }, 300);
  }

  updateSearch(searchTerm: string) {
    this.pageChange(1);
    this.vehicles = this.vehiclesBackup.filter((vehicle, index) => {
      return (vehicle.manufacturer.toLowerCase().search(searchTerm.toLowerCase()) !== -1)
        || (vehicle.name.toLowerCase().search(searchTerm.toLowerCase()) !== -1)
        || (vehicle.description.toLowerCase().search(searchTerm.toLowerCase()) !== -1)
        ;
    });
  }

  scroll(element) {
    const el = document.getElementById(element);
    el.scrollIntoView({behavior: 'smooth'});
  }

}
